// extracted by mini-css-extract-plugin
module.exports = {"navDetial":"NavChild_navDetial__sZ3Qt"};